<template>
  <v-card-text>
    <v-layout class="align-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-chip class="clickable info--text" label small v-on="on">
            {{ labels[formatType].label }}
            <v-icon color="info">arrow_drop_down</v-icon>
          </v-chip>
        </template>
        <v-list>
          <v-list-tile @click="setType('every')">
            <v-list-tile-content>
              <v-list-tile-title>Every</v-list-tile-title>
              <!-- <v-list-tile-sub-title>Repeat every few minutes at the specified interval.</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="setType('atSpecific')">
            <v-list-tile-content>
              <v-list-tile-title>At</v-list-tile-title>
              <!-- <v-list-tile-sub-title>Occur at specific minutes.</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="setType('betweenRange')">

            <v-list-tile-content>
              <v-list-tile-title>Between</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="setType('custom')">
            <v-list-tile-content>
              <v-list-tile-title>Custom</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <template v-if="formatType == 'every'">
        <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" :class="{ 'error--text': !validation.every.isValid, 'mr-2 py-1 pr-1 cron-input': true }" type="number" v-model.number="val.every" hide-details />
        {{ val.every == 1 ? 'day' : 'days' }} of the week
      </template>
      <template v-else-if="formatType == 'atSpecific'">
        On day <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" min="0" max="60" v-model.number="val.atSpecific" hide-details />
        of the month
      </template>
      <template v-else-if="formatType == 'betweenRange'">
        <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" v-model.number="val.betweenDaysStart" />
        and
        <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" v-model.number="val.betweenDaysEnd" hide-details />
        of the month
      </template>
      <template v-else-if="formatType == 'custom'">
        <input @input="calculateValue()" @keydown.space.prevent style="width: 200px; text-align: left;" class="mx-2 pa-1 cron-input" v-model="val.custom" hide-details />
      </template>
    </v-layout>
    <v-layout>
      <template v-if="formatType == 'every'">

      </template>
      <template v-else-if="formatType == 'atSpecific'">

      </template>
      <template v-else-if="formatType == 'betweenRange'">

      </template>
      <template v-else-if="formatType == 'custom'">
        A comma-delimited combination of the previous selections.
      </template>
    </v-layout>
  </v-card-text>
</template>

<script>
  const everyRegexLax = /^(\*)([^\s^\,]*)$/g
  const everyRegexCorrect = /^(\*)(\/([0-7]))?$/g

  const atSpecificLax = /^(\d)*$/g
  const atSpecificCorrect = /^([0-7])$/g

  const betweenDaysLax = /^([\d]*)-([\d]*)$/g
  const betweenDaysCorrect = /^([0-7])-([0-7])$/g

  const customLax = /^((\d+,)+\d+|(\d+-\d+,?)|\d+|(\*(\/\d+)?),?)+$/g
  const customCorrect = /^(([0-7]+,)+[0-7]+|([0-7]+-[0-7]+,?)|[0-7]+|(\*(\/[0-7]+)?),?)+$/g

  const normalizeOutput = (val) => val.toString().replace(' ', '')

  export default {
    props: {
      value: [String],
    },
    data: () => ({
      formatType: 'every',
      labels: {
        every: {
          label: 'Every',
        },
        atSpecific: {
          label: 'On day',
        },
        betweenRange: {
          label: 'Between',
        },
        custom: {
          label: 'Custom',
        },
      },
      validation: {
        every: {
          isValid: true,
          message: 'Invalid syntax',
        },
        atSpecific: {
          isValid: true,
        },
        betweenDays: {
          isValid: true,
        },
        custom: {
          isValid: true,
        },
      },
      val: {
        every: 5,
        atSpecific: 7,
        betweenDaysStart: 2,
        betweenDaysEnd: 4,
        custom: '*/2,4-6',
      },
      output: null,
    }),
    watch: {
      value: {
        immediate: true,
        handler(val) {
          Object.values(this.validation).forEach(item => item.isValid = true)
          let match

          if (this.formatType != 'custom') {
            match = val.match(everyRegexLax)
            if (match) {
              this.formatType = 'every'
              match = val.match(everyRegexCorrect)
              if (!match) this.validation.every.isValid = false

              let normalized = val.replace('*', '')
              if (normalized.trim().length == 0) normalized = '1'
              else normalized = normalized.replace('/', '')

              this.val.every = normalized
              return
            }

            match = val.match(atSpecificLax)
            if (match) {
              this.formatType = 'atSpecific'
              this.val.atSpecific = val
              match = val.match(atSpecificCorrect)
              if (!match) this.validation.atSpecific.isValid = false
              return
            }

            match = val.match(betweenDaysLax)
            if (match) {
              this.formatType = 'betweenDays'
              let split = val.split('-')
              this.val.betweenDaysStart = split[0]
              this.val.betweenDaysEnd = split[1]
              match = val.match(betweenDaysCorrect)
              if (!match) this.validation.betweenDays.isValid = false
              return
            }
          }

          match = val.match(customLax)
          if (match) {
            this.formatType = 'custom'
            this.val.custom = val

            match = val.match(customCorrect)
            if (!match) this.validation.custom.isValid = false
            return
          } else {
            this.validation.custom.isValid = false
          }
        },
      },
      output(val) {
        this.$emit('input', val)
      },
      validation: {
        deep: true,
        handler(val) {
          let error = Object.values(val).some(item => !item.isValid)
          this.$emit('isValid', !error)
        },
      },
    },
    methods: {
      setType(type) {
        this.formatType = type
        this.calculateValue()
      },
      calculateValue() {
        switch (this.formatType) {
        case 'every':
          this.output = '*/' + normalizeOutput(this.val.every)
          break
        case 'atSpecific':
          this.output = normalizeOutput(this.val.atSpecific.toString())
          break
        case 'betweenDays':
          this.output = normalizeOutput(this.val.betweenDaysStart + '-' + this.val.betweenDaysEnd)
          break
        case 'custom':
          this.output = normalizeOutput(this.val.custom.toString())
          break
        default:
          this.output = '*'
          break
        }
      },
    },
  }
</script>

<style scoped>
  .cron-input {
    background-color: #f3f3f3;
    flex-grow: 0;
    text-align: center;
  }
</style>